import { render, staticRenderFns } from "./DefinitiveShow.vue?vue&type=template&id=387e4b80&scoped=true&"
import script from "./DefinitiveShow.vue?vue&type=script&lang=js&"
export * from "./DefinitiveShow.vue?vue&type=script&lang=js&"
import style0 from "./DefinitiveShow.vue?vue&type=style&index=0&id=387e4b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387e4b80",
  null
  
)

export default component.exports